const { designationList } = require("constants/designation");

const initialState = {
  designationList: {},
};

const designation = (state = initialState, action) => {
  switch (action.type) {
    case designationList:
      return { ...state, designationList: action.payload };

    default:
      return state;
  }
};
export default designation;
